import { tw } from "@careinfo/tailwind";
import { ColumnDef } from "@tanstack/react-table";
import moment from "moment";
import { useForm, useWatch } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import StockLedgerDetailTable from "../Reusable/StockLedgerDetailTable";
import Filter from "./Filter";
import { useDownload } from "@careinfo/layout";

import Button from "../Reusable/Button";

const StockLedgerDetail = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  const { download } = useDownload();
  const {
    control,
    register,
    getValues,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      account: searchParams.get("account") || "",
      user: searchParams.get("user") || "",
      created: searchParams.get("created") || "",
      created__range: `${startOfMonth},${endOfMonth}`,
    },
  });

  const formValues = useWatch({ control });
  const columns: ColumnDef<any, any>[] = [
    {
      accessorKey: "created",
      header: "Date",
      cell: ({ getValue }: any) => {
        return (
          <p>
            {getValue() ? moment(getValue()).format("YY-MM-DD HH:mm:ss") : ""}
          </p>
        );
      },
    },
    {
      accessorKey: "created_miti",
      header: "Miti",
      cell: ({ getValue }: any) => {
        return (
          <p>
            {getValue() ? moment(getValue()).format("YY-MM-DD HH:mm:ss") : ""}
          </p>
        );
      },
    },
    {
      accessorKey: "bill.bill_no",
      header: "Bill No.",
    },
    {
      accessorKey: "bill.party",
      header: "Particulars",
    },
    {
      accessorKey: "quantity",
      header: () => (
        <div className={tw`text-center`}>
          <p>Received</p>
          <div className={tw`flex justify-around`}>
            <span>Quantity </span>
            <span>Rate </span>
            <span>Value</span>
          </div>
        </div>
      ),
      cell: ({ row, getValue }: any) => {
        return <p>{row?.original?.is_sales ? "" : getValue()}</p>;
      },
    },
    {
      accessorKey: "quantity",
      header: () => (
        <div className={tw`text-center`}>
          <p>Delivered</p>
          <div className={tw`flex justify-around`}>
            <span>Quantity </span>
            <span>Rate </span>
            <span>Value</span>
          </div>
        </div>
      ),
      cell: ({ row, getValue }: any) => {
        return <p> {row?.original?.is_sales ? getValue() : ""}</p>;
      },
    },
  ];
  const handleDownloadExcel = async () => {
    try {
      const cleanedParams = Object.fromEntries(
        Object.entries(formValues)
          .filter(
            ([, value]) => value !== null && value !== undefined && value !== ""
          )
          .map(([key, value]) => [key, String(value)])
      );

      const queryString = new URLSearchParams(cleanedParams).toString();

      await download(
        `${APIS.PRODUCT}detail-ledger-excel-download/?${queryString}`,
        `stock-valuation-${moment().format("MMMM-Do-YYYY-h-mm-ss")}.xlsx`
      );
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <>
      <Filter
        register={register}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <div className={tw`flex justify-end mb-2`}>
        <div className={tw`w-24`}>
          <Button label="Download" onClick={() => handleDownloadExcel()} />
        </div>
      </div>
      <StockLedgerDetailTable
        customSearch={true}
        columns={columns}
        queryKey="stock-ledger"
        url={`${APIS.PRODUCT}stock-ledger/`}
        params={formValues}
      />
    </>
  );
};

export default StockLedgerDetail;

